import { render, staticRenderFns } from "./InputTextAreaComp.vue?vue&type=template&id=413012db&scoped=true"
import script from "./InputTextAreaComp.vue?vue&type=script&lang=js"
export * from "./InputTextAreaComp.vue?vue&type=script&lang=js"
import style0 from "./InputTextAreaComp.vue?vue&type=style&index=0&id=413012db&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "413012db",
  null
  
)

export default component.exports